'use client';

import Link from 'next/link';
import {
  type ComponentProps,
  type FC,
  type ReactNode,
  useEffect,
  useState,
} from 'react';
import { useSessionStorage } from 'usehooks-ts';
import { SESSION_KEY } from '../utm-capture/utm-capture';

type DefaultLinkProps = Omit<ComponentProps<typeof Link>, 'href'>;

interface SignupLinkWithUTMProps extends DefaultLinkProps {
  children: ReactNode;
  href?: string;
}

export const SignupLinkWithUTM: FC<SignupLinkWithUTMProps> = ({
  children,
  href,
  ...props
}) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [utmValues] = useSessionStorage<string>(SESSION_KEY, '');

  const dashboardUrl = process.env.NEXT_PUBLIC_DASHBOARD_URL;

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const finalHref = utmValues
    ? `${dashboardUrl}/sign-up?${utmValues}`
    : `${dashboardUrl}/sign-up`;

  if (!isHydrated) {
    return null;
  }

  return (
    <Link href={finalHref} {...props}>
      {children}
    </Link>
  );
};
